import e from"styled-components";import{theme as i}from"../../../theme.js";const n=e.div`
  display: flex;
  flex-direction: column;
  gap: ${i.spacing*4}px;
  padding: 0 ${i.spacing*4}px;
  height: fit-content;
  box-sizing: border-box;
  @media screen and (max-width: ${i.breakpoints.md}) {
    padding: ${i.spacing*4}px;
  }
`,r=e.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${i.colors.error[50]};
  width: 90px;
  height: 90px;
  > svg {
    width: 60px;
    height: 60px;
    > g, path {
      fill: ${i.colors.error[500]};
    }
  }
`,t=e.p`
  margin: 0;
  line-height: 32px;
  color: ${i.colors.gray[500]};
  @media screen and (max-width: ${i.breakpoints.md}) {
    text-align: center;
  }
`,o=e.div`
  display: flex;
  gap: ${i.spacing*4}px;
  align-items: center;
  @media screen and (max-width: ${i.breakpoints.md}) {
    flex-direction: column;
  }
`;export{n as Container,t as Description,r as IconContainer,o as Wrapper};
